module.exports = __webpack_public_path__ + "static/media/info-circle.03745b29.svg";